import { orderBy } from "lodash";

import { createSlice } from "@reduxjs/toolkit";

import { axiosGet } from "../../../api/axiosCalls";
import { setError } from "../errorSlice";
import { mapAndSortTerritories } from "./maps";

const initialState = {
  isStatesLoading: false,
  territoryList: [],
  stateList: [],
  filteredStateList: [],
  compliantStateList: [],
};

const loadingFailed = (state) => {
  state.isStatesLoading = false;
};

const territorySlice = createSlice({
  name: "territories",
  initialState,
  reducers: {
    setStatesLoading(state) {
      state.isStatesLoading = true;
    },
    getAllTerritoriesSuccess(state, action) {
      const { territories } = action.payload;
      state.territoryList = territories;
    },
    getStatesSuccess(state, action) {
      const { states } = action.payload;
      state.filteredStateList = states;
      state.isStatesLoading = false;
    },
    getAllStatesSuccess(state, action) {
      const { states } = action.payload;
      state.stateList = states;
      state.isStatesLoading = false;
    },
    getCompliantStatesSuccess(state, action) {
      const { states } = action.payload;
      state.compliantStateList = states;
      state.isStatesLoading = false;
    },
    clearFilteredStates(state) {
      state.filteredStateList = [];
    },
    setFailure: loadingFailed,
  },
});

export const {
  setStatesLoading,
  getAllTerritoriesSuccess,
  getStatesSuccess,
  getAllStatesSuccess,
  getCompliantStatesSuccess,
  clearFilteredStates,
  setFailure,
} = territorySlice.actions;

export default territorySlice.reducer;

export const fetchTerritories = () => async (dispatch) => {
  try {
    const response = await axiosGet("/api/territories");
    if (response.error) throw response.error;
    const mappedData = mapAndSortTerritories(response.data);
    dispatch(getAllTerritoriesSuccess({ territories: mappedData }));
  } catch (err) {
    dispatch(setFailure());
    dispatch(setError({ error: err.toString(), source: "Territories" }));
  }
};

export const fetchStates = () => async (dispatch) => {
  try {
    dispatch(setStatesLoading());
    const response = await axiosGet("/api/states");
    if (response.error) throw response.error;
    const stateArray = response.data.filter((s) => s.country === "USA");
    const sortedStates = stateArray.sort((a, b) => {
      return a.code < b.code ? -1 : a.code > b.code ? 1 : 0;
    });
    dispatch(getAllStatesSuccess({ states: sortedStates }));
  } catch (err) {
    dispatch(setFailure());
    dispatch(setError({ error: err.toString(), source: "Territories" }));
  }
};

export const fetchStatesByIds = (ids) => async (dispatch) => {
  try {
    dispatch(setStatesLoading());
    if (ids.length === 1 && ids[0] === null) {
      dispatch(getStatesSuccess({ states: [] }));
    } else {
      const queryString =
        ids.length > 0
          ? `/api/states?filter[territory-id]=${ids.join(",")}`
          : "/api/states";
      const response = await axiosGet(queryString);
      if (response.error) throw response.error;
      const sortedStates = orderBy(
        response.data,
        [(state) => state.code, (state) => state.country.toLowerCase()],
        ["asc", "asc"]
      );
      dispatch(getStatesSuccess({ states: sortedStates }));
    }
  } catch (err) {
    dispatch(setFailure());
    dispatch(setError({ error: err.toString(), source: "Territories" }));
  }
};

export const fetchAllCompliantStates = (id, type) => async (dispatch) => {
  try {
    dispatch(setStatesLoading());
    const typeMap = {
      order: "compliant_for_order_id",
      "order-variant": "compliant_for_order_item_id",
      "param-item": "compliant-for-shipping-parameter-id",
    };
    const response = await axiosGet(
      `/api/states?filter[${typeMap[type]}]=${id}`
    );
    if (response.error) throw response.error;
    dispatch(getCompliantStatesSuccess({ states: response.data }));
  } catch (err) {
    dispatch(setFailure());
    dispatch(setError({ error: err.toString(), source: "Territories" }));
  }
};
